export class FooterLabel_EN {

    footer: {
        footerText: string;
        terms: string;
        about: string;
        privacy: string;
        userAgreement: string;
        poweredBy: string;
    }

    footerBtn: {
        agree: string;
        close: string;
    }

    constructor() {

        this.footer = {
            footerText: "Copyright 2018. Nissan Motor Co. Ltd.",
            terms: "Terms and Conditions",
            about: "About Us",
            privacy: "Privacy Policy",
            userAgreement: "Accept the user agreement",
            poweredBy: "Powered By"
        }

        this.footerBtn = {
            agree: "Agree",
            close: "Close"
        }
    }
}